"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrMaintenanceNotificationBody = exports.FdrMaintenanceNotificationHeader = void 0;
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const styled_components_1 = __importDefault(require("styled-components"));
exports.FdrMaintenanceNotificationHeader = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'warning',
    alignItems: 'center',
    py: [2, '12px'],
    px: '20px',
    color: 'white',
    '.warning-notification-title': {
        fontSize: [2, 4],
        fontWeight: 'bold',
    },
    '.warning-notification-button': {
        backgroundColor: 'transparent',
        padding: 0,
    },
}), ({ theme }) => ({
    '.warning-notification-icon': Object.assign(Object.assign({}, theme.icons.md), { [theme.media.tablet]: theme.icons.xlg }),
}));
exports.FdrMaintenanceNotificationBody = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    px: '20px',
    py: ['12px', 3],
    backgroundColor: 'bgWarning',
    fontSize: [2, 3],
}));
//# sourceMappingURL=fdr-maintenance-notification.styles.js.map